import { canReviewAccessRequests } from '@infras/shared-types';
import { AdminGate } from '../components/AdminGate';
import { RequestQuestions } from '../components/RequestQuestions';
import { useMe } from '../lib/useMe';

/** Administration → Request questions. Kept for the historical answers already on
 *  older requests; new requests no longer collect them. */
export function RequestQuestionsPage() {
  const { me } = useMe();
  return (
    <AdminGate allowed={!!me && canReviewAccessRequests(me.role)} need="reviewers and root users">
      <div className="page stack access-admin-page">
        <div className="detail-head">
          <h2>Request questions</h2>
          <span className="tag-badge tag-badge--warn">not shown on new requests</span>
        </div>
        <p className="detail-desc">
          The request form now asks four fixed questions, so these templates are no longer served to
          requesters. They stay here because requests filed earlier still render the answers they
          collected — editing a template does not change those historical answers.
        </p>
        <RequestQuestions />
      </div>
    </AdminGate>
  );
}
